import { strFromU8, unzipSync } from "fflate";
export default class ZIPUnpacker {
    static parse(fileList, data, dir) {
        return new Promise((resolve, reject) => {
            let textFiles = [".sm", ".qua", ".osu", ".txt"];
            let files = unzipSync(new Uint8Array(data));
            let fileNames = Object.keys(files);
            for (let i = 0; i < fileNames.length; i++) {
                let filePath = dir + fileNames[i];
                let fileData = files[fileNames[i]];
                // Skip Empty Files / Directories
                if (fileData.length <= 0)
                    continue;
                let hasPath = filePath.indexOf("/") !== -1;
                let fileDir = hasPath ? filePath.substring(0, filePath.lastIndexOf("/") + 1) : "";
                let fileName = hasPath ? filePath.substring(fileDir.length) : filePath;
                // Parse text files into strings.
                let fileExtension = filePath.substring(filePath.lastIndexOf("."));
                let hasExtension = fileExtension.indexOf(".") >= 0;
                if (hasExtension && textFiles.indexOf(fileExtension) !== -1) {
                    fileData = strFromU8(fileData);
                }
                // Add to list.
                let file = {
                    name: fileName,
                    dir: fileDir,
                    path: fileDir + fileName,
                    data: fileData
                };
                fileList.push(file);
            }
            resolve(true);
        });
    }
}
